module.exports = __webpack_public_path__ + "static/media/collaborators.f076ade7.svg";